import BoardContentNewsApi from '@app/api/public/BoardContentNewsApi';
import { useQuery } from 'react-query';

export const boardNewsQueryKeys = {
    all: [{ scope: 'boardNews' }] as const,
    lists: () => [{ ...boardNewsQueryKeys.all[0], entity: 'list' }] as const,
    list: (type: 'draft' | 'published', page: number) => [{ ...boardNewsQueryKeys.lists()[0], type, page }] as const,
    infiniteLists: () => [{ ...boardNewsQueryKeys.all[0], entity: 'infiniteList' }] as const,
    infiniteList: (type: 'draft' | 'published', page: number) =>
        [{ ...boardNewsQueryKeys.infiniteLists()[0], type, page }] as const,
    details: () => [{ ...boardNewsQueryKeys.all[0], entity: 'detail' }] as const,
    detail: (id: number) => [{ ...boardNewsQueryKeys.details()[0], id }] as const,
    documents: () => [{ ...boardNewsQueryKeys.all[0], entity: 'document' }] as const,
    document: (id: number) => [{ ...boardNewsQueryKeys.documents()[0], id }] as const,
};

const getPageListItems = async (type: 'draft' | 'published', page: number) => {
    return await BoardContentNewsApi.list(type, page);
};

const useGetContentNewsList = (type: 'draft' | 'published', page: number) => {
    return useQuery({
        queryFn: ({ queryKey }) => {
            const { type } = queryKey[0];
            return getPageListItems(type, page);
        },
        queryKey: boardNewsQueryKeys.list(type, page),
    });
};

const getContentNews = (id: number) => {
    return BoardContentNewsApi.get(id);
};

const useGetBoardNewsById = (id: number) => {
    return useQuery({
        queryFn: ({ queryKey }) => getContentNews(queryKey[0].id),
        queryKey: boardNewsQueryKeys.detail(id),
        enabled: !!id,
    });
};

export { useGetContentNewsList, useGetBoardNewsById };
